import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { LucideAngularModule } from "lucide-angular";
import { InviteMemberButtonModule } from "../organization-page/component/invite-member-button/invite-member-button.module";
import { OrganizationDetailsModule } from "../organization-page/component/organization-details/organization-details.module";
import { AdministrationPageComponent } from "./administration-page.component";

@NgModule({
  declarations: [AdministrationPageComponent],
  imports: [
    CommonModule,
    TranslateModule,
    RouterModule,
    FormsModule,
    LucideAngularModule,
    OrganizationDetailsModule,
    InviteMemberButtonModule,
  ],
})
export class AdministrationPageModule {}
